"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JSErrors = exports.Instrument = void 0;
var _handle = require("../../../common/event-emitter/handle");
var _instrumentBase = require("../../utils/instrument-base");
var _constants = require("../constants");
var _runtime = require("../../../common/constants/runtime");
var _eventListenerOpts = require("../../../common/event-listener/event-listener-opts");
var _now = require("../../../common/timing/now");
var _constants2 = require("../../session_replay/constants");
var _castError = require("../shared/cast-error");
/*
 * Copyright 2020 New Relic Corporation. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

class Instrument extends _instrumentBase.InstrumentBase {
  static featureName = _constants.FEATURE_NAME;
  #replayRunning = false;
  constructor(agentIdentifier, aggregator, auto = true) {
    super(agentIdentifier, aggregator, _constants.FEATURE_NAME, auto);
    try {
      // this try-catch can be removed when IE11 is completely unsupported & gone
      this.removeOnAbort = new AbortController();
    } catch (e) {}
    this.ee.on('internal-error', error => {
      if (!this.abortHandler) return;
      (0, _handle.handle)('ierr', [(0, _castError.castError)(error), (0, _now.now)(), true, {}, this.#replayRunning], undefined, this.featureName, this.ee);
    });
    this.ee.on(_constants2.SR_EVENT_EMITTER_TYPES.REPLAY_RUNNING, isRunning => {
      this.#replayRunning = isRunning;
    });
    _runtime.globalScope.addEventListener('unhandledrejection', promiseRejectionEvent => {
      if (!this.abortHandler) return;
      (0, _handle.handle)('err', [(0, _castError.castPromiseRejectionEvent)(promiseRejectionEvent), (0, _now.now)(), false, {
        unhandledPromiseRejection: 1
      }, this.#replayRunning], undefined, this.featureName, this.ee);
    }, (0, _eventListenerOpts.eventListenerOpts)(false, this.removeOnAbort?.signal));
    _runtime.globalScope.addEventListener('error', errorEvent => {
      if (!this.abortHandler) return;
      (0, _handle.handle)('err', [(0, _castError.castErrorEvent)(errorEvent), (0, _now.now)(), false, {}, this.#replayRunning], undefined, this.featureName, this.ee);
    }, (0, _eventListenerOpts.eventListenerOpts)(false, this.removeOnAbort?.signal));
    this.abortHandler = this.#abort; // we also use this as a flag to denote that the feature is active or on and handling errors
    this.importAggregator();
  }

  /** Restoration and resource release tasks to be done if JS error loader is being aborted. Unwind changes to globals. */
  #abort() {
    this.removeOnAbort?.abort();
    this.abortHandler = undefined; // weakly allow this abort op to run only once
  }
}
exports.Instrument = Instrument;
const JSErrors = exports.JSErrors = Instrument;